import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing the position-plus icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <PositionPlusIcon width={12} />
 */
const PositionPlusIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M29.12,17.23A10.17,10.17,0,0,1,26.2,9.07,17.73,17.73,0,0,0,6.87,12.81a17.46,17.46,
            0,0,0-.11,24.68l.12.12C10.07,40.78,19.35,48,19.35,48s9.27-7.22,12.47-10.39a17.45,17.45,0,0,0,
            4.44-17.38A10.15,10.15,0,0,1,29.12,17.23Zm-9.91,16.2A8.82,8.82,0,1,1,28,24.61,8.82,8.82,0,0,1,
            19.21,33.43ZM46.29,8a2.11,2.11,0,0,1-2.11,2.11H40.41v3.78a2.12,2.12,0,0,1-4.23,0V10.11H32.41a2.11,
            2.11,0,1,1,0-4.22h3.77V2.11a2.12,2.12,0,0,1,4.23,0V5.89h3.77A2.11,2.11,0,0,1,46.29,8Z`}
        />
    </SvgIcon>
)

PositionPlusIcon.defaultProps = defaultProps

export { PositionPlusIcon }
